var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"home-wrapper"},[_c('a-icon',{staticClass:"home-icon",style:({ fontSize: '16px' }),attrs:{"theme":"filled","type":"home"},on:{"click":_vm.backToHome}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }